import axios from 'axios';
import endpoints from '@/api/endpoints';
import store from '@/store';
import miscServices from '@/services/misc';

export default {
  async getProjectEstimates (projectID) {
    // Returns all estimates for a given project
    console.log('getting project estimates')
    return axios.get(endpoints.estimates + '?project=' + projectID).then((response) =>  {
      return response.data
    })
  },

  async createEstimateTemplate (est) {
    // This will create a new estimate object, and a related estimate detail object
    // That is, for Snow division, it will create a SnowEstimate object and connect
    // it to the main Estimate object, and return the whole thing upon completion
    let newEst = await this.createEstimate(est)

    // Now figure out the division type, and what kind of estimate detail object
    // is needed. Division types are outlined in the `global_options` endpoint
    const div = store.state.misc.divisions.find(d => d.id === newEst.division)
    console.log(div)
    switch (div.division_type) {
      case 'S':
        // Snow estimate
        await this.createSnowEstimate({ 'estimate': newEst.id }) // At this point, we only know the estimate ID
        break
    }
    return newEst;
  },
  async createEstimate (est) {
    return axios.post(endpoints.estimates, est).then((response) => {
      return response.data
    }).catch(error => { 
      return miscServices.handleAPIError(error)
    })
  },
  async addFileToEstimate (est, file) {
    return axios.post(endpoints.estimates + est + '/upload_file/', {'file_id': file})
    .then((response) => {
      return response.data;
    }).catch(err => {
      console.log(err.response.data);
    });
  },
  async sellEstimate (id) {
    return axios.post(endpoints.estimates + id + '/sell/')
    .then((response) => {
      return response.data;
    }).catch(err => { 
      console.log(err.response.data);
    });
  },
  async getEstimates (id = null) {
    if (id) {
      id = id + '/'
    } else {
      id = '?is_template=false'
    }
    return axios.get(endpoints.estimates + id).then((response) => {
      return response.data
    })
  },
  async getEstimatesReadyToSell () {
    return axios.get(endpoints.estimates + '?is_sold=false&is_ready_to_sell=true&archived=false').then((response) => {
      return response.data
    })
  },
  async getArchivedEstimates () {
    return axios.get(endpoints.estimates + '?archived=true').then((response) => {
      return response.data
    })
  },
  async getSoldEstimates () {
    return axios.get(endpoints.estimates + '?is_sold=true').then((response) => {
      return response.data 
    })
  },
  async getUnsoldEstimates () {
    return axios.get(endpoints.estimates + '?is_sold=false&archived=false&is_template=false&is_ready_to_sell=false').then((response) => {
      return response.data
    })
  },
  async getSnowTemplate (snowID) {
    return axios.get(endpoints.snowEstimates + snowID + '/').then((response) => {
      return response.data
    })
  },
  async getDivisionEstimates (divID) {
    return axios.get(endpoints.estimates + '?division=' + divID + '&is_template=false').then((response) => {
      return response.data
    })
  },
  async getDivisionTemplates (divID) {
    return axios.get(endpoints.estimates + '?division=' + divID + '&is_template=true').then((response) => {
      return response.data
    })
  },
  async getSnowEstimates (id = null) {
    if (id) {
      id = id + '/'
    } else {
      id = ''
    }
    return axios.get(endpoints.snowEstimates + id).then((response) => {
      return response.data
    })
  },
  async getIrrigationEstimate (id) {
    return axios.get(endpoints.irrigationEstimates + id).then((response) => {
      return response.data
    })
  },
  async getLawnEstimate (id) {
    return axios.get(endpoints.lawnEstimates + id).then((response) => {
      return response.data
    })
  },
  async createSnowEstimate (est) {
    return axios.post(endpoints.snowEstimates, est).then((response) => {
      return response.data
    })
  },
  async createIrrigationEstimate (est) {
    return axios.post(endpoints.irrigationEstimates, est).then((response) => {
      return response.data
    })
  },
  async createLawnEstimate (est) {
    return axios.post(endpoints.lawnEstimates, est).then((response) => {
      return response.data
    })
  },
  async updateSnowEstimate (est) {
    return axios.patch(endpoints.snowEstimates + est.id + '/', est).then((response) => {
      return response.data
    })
  },
  async updateIrrigationEstimate (est) {
    return axios.patch(endpoints.irrigationEstimates + est.id + '/', est).then((response) => {
      return response.data
    })
  },
  async updateLawnEstimate (est) {
    return axios.patch(endpoints.lawnEstimates + est.id + '/', est).then((response) => {
      return response.data
    })
  },
  async getEstimateTemplates (div = null) {
    let search = ''
    if (div) {
      search = '?division=' + div
    }
    return axios.get(endpoints.estimates + '?is_template=true' + search).then((response) => {
      return response.data
    })
  },
  async updateEstimate (est) {
    delete est.files // bandaid for files issues - MJ (since an older files array may overwrite recently attached files on est edit/save)
    return axios.patch(endpoints.estimates + est.id + '/', est).then((response) => {
      return response.data
    })
  },
  async emailEstimate(id, payload, show_price) {
    const url = 'email-estimate/' + `?pk=${id}&show_price=${show_price}`;
    return axios.post(url, payload)
    .then((response) => {
        return response.data;
    }).catch(err => {
        console.log(err.response.data);
    });
  },
  async previewEstimate(estID) {
    return axios.get(endpoints.previewEstimate + estID + '/').then((response) => {
      return response.data
    })
  },
  async emailEstimateConfirmation(estID) {
    return axios.get(endpoints.emailEstimateConfirmation + estID + '/').then((response) => {
      return response.data
    })
  },

  // ----- Stickies
  async getEstimateStickies (estimateID) {
    return axios.get(endpoints.stickies + '?estimate=' + estimateID).then((response) => {
      return response.data
    })
  },
  async addEstimateSticky (payload) {
    return axios.post(endpoints.stickies, payload).then((response) => {
      return response.data
    })
  },
  async updateEstimateSticky (payload) {
    return axios.patch(endpoints.stickies + payload.id + '/', payload).then((response) => {
      return response.data
    })
  },
  async removeEstimateSticky (payload) {
    return axios.delete(endpoints.stickies + payload.id + '/').then((response) => {
      return response.data
    })
  },
}
